<template>
  <a-result status="404" :title="title" :sub-title="subTitle">
    <template #extra>
      <a-button type="primary" @click="toHome">
        Back Home
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  name: 'Exception404',
  data(){
    return{
      title:'',
      subTitle:''
    }
  },
  methods: {
    toHome () {
      this.$router.push({ path: '/' })
    }
  },
  created(){
    // console.log('1:',window.location.search); 
    // console.log('2:',this.$route.desc)
    // console.log('3:',this.$route.params.desc)
    // console.log('4:',this.$route.query.desc)  // 可以接受到参数
    this.title = this.$route.query.desc
    this.subTitle = '抱歉，您访问的' + this.$route.query.desc +  '页面不存在。'
  },
  mounted(){

  }
}
</script>



// WEBPACK FOOTER //
// src/components/404.vue